// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"AccessDenied_ErrorContainer__bOSb8","LockIcon":"AccessDenied_LockIcon__1-WCX"};